import _ from "lodash";

export default class NumberUtils {
  static safeParseInt(value, radix = 10) {
    const parsedValue = _.parseInt(
      _.toString(value)
        .trim()
        .replace(/^0+(?=\d)/, ""),
      radix
    );

    return _.isSafeInteger(parsedValue) ? parsedValue : 0;
  }
}
